import { AppProviders } from "providers/AppProviders";
import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Route, Routes } from "react-router";
import reportWebVitals from "./reportWebVitals";
import { isDevEnv, isProductionEnv } from "constants/environment";
import { flags } from "constants/featureFlags";
import LandingPage from "pages/LandingPage/LandingPage";
import { ErrorRoutes } from "routes/ErrorRoutes";
import { MyOrdersRoutes } from "routes/MyOrdersRoutes.tsx";
import { CustomColorRoutes } from "routes/CustomColorRoutes";
import { NewOrdersRoutes } from "routes/NewOrdersRoutes.tsx";
import { AddOnsRoutes } from "routes/AddOnsRoutes.tsx";
import { ReplacementsRoutes } from "routes/ReplacementsRoutes.tsx";
import { CustomQuotesRoutes } from "routes/CustomQuotesRoutes.tsx";
import { TrucksRoutes } from "routes/TrucksRoutes.tsx";
import { UserPreferencesRoutes } from "routes/UserPreferencesRoutes.tsx";
import { LeadGenRoutes } from "routes/LeadGenRoutes/LeadGenRoutes.tsx";
import { NewOrderQuoteRoutes } from "routes/NewOrderQuoteRoutes/NewOrderQuoteRoutes.tsx";
import { MarketingMaterialsRoutes } from "./routes/MarketingMaterialsRoutes.tsx";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const luckyOrangeFeatureFlagProd = `${flags.env}` === "prod";
const luckyOrangeFeatureFlagLowerEnvs = `${flags.env}` !== "prod";

const loadLuckyOrangeScript = () => {
	if (luckyOrangeFeatureFlagProd) {
		const prodScriptTag = document.createElement("script");
		prodScriptTag.src = "https://tools.luckyorange.com/core/lo.js?site-id=51dd4464";
		prodScriptTag.async = true;
		prodScriptTag.defer = true;

		document.head.appendChild(prodScriptTag);
	} else if (luckyOrangeFeatureFlagLowerEnvs) {
		const lowerEnvsScriptTag = document.createElement("script");
		lowerEnvsScriptTag.src = "https://tools.luckyorange.com/core/lo.js?site-id=1d1dd2b8";
		lowerEnvsScriptTag.async = true;
		lowerEnvsScriptTag.defer = true;

		document.head.appendChild(lowerEnvsScriptTag);
	}
};

if (isProductionEnv) {
	window.onload = loadLuckyOrangeScript;
}

export const AppTree = (
	<StrictMode>
		<AppProviders>
			<Routes>
				{ErrorRoutes}
				<Route
					path="/"
					element={<LandingPage />}
				>
					{MyOrdersRoutes}
					{CustomColorRoutes}
					{NewOrdersRoutes}
					{AddOnsRoutes}
					{NewOrderQuoteRoutes}
					{ReplacementsRoutes}
					{CustomQuotesRoutes}
					{TrucksRoutes}
					{UserPreferencesRoutes}
					{LeadGenRoutes}
					{MarketingMaterialsRoutes}
				</Route>
			</Routes>
		</AppProviders>
	</StrictMode>
);

function render() {
	root.render(AppTree);
}

if (isDevEnv && import.meta.env.VITE_APP_MOCKED) {
	import("mocks/server/devServer").then((startDevServer) => {
		startDevServer.default().then(() => render());
	});
} else {
	render();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
